module.exports = __webpack_public_path__ + "img/prime-earn-logo.05b27e84.png";